import axios from 'axios';

const state = () => ({});

const getters = {};

const actions = {
  async sendSMS({ }, data) {
    if (Array.isArray(data) || data.provider === 'smsimple') {
      const body = Array.isArray(data) ? data : [{ numbers: data.numbers, text: data.message }];
      await axios.post("https://sms-api.globalfibra.com.br/messages", body,
        {
          headers: {
            Authorization: 'bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI1OTIwYzNhNS0yYzgzLTQwODgtODQ1OC0wMzQzMWRkYzk3YTQiLCJ1c2VyVG9rZW4iOnRydWUsImlhdCI6MTYzMzUzNzQxNH0.jqjO7FrRQjV4fggwkzqaqWykHyv-Z4OjJxhkcemy0nw'
          }
        });
    } else if (data.provider === 'smsgestor') {
      const {
        numbers,
        message,
        subject,
      } = data;

      await this.$http.post("/sms/send", {
        numbers,
        message,
        subject,
      });
    } else if (data.provider === 'disparopro') {
      const {
        numbers,
        message,
        subject,
      } = data;

      await this.$http.post("/sms/send/disparo-pro", {
        numbers,
        message,
        subject,
      });
    } else {
      throw new Error('Provedor inválido');
    }
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
